import { FC } from 'react'
import { Backdrop } from '@mui/material'

import { useAppSelector } from '@hooks'
import { GLOBAL_OVERLAY_ZINDEX_INCREASE } from '@constants'

export const GlobalUIOverlay: FC = () => {
  const isOverlayShown = useAppSelector(state => state.uiOverlay.isOverlayShown)

  return (
    <Backdrop
      open={isOverlayShown}
      sx={{
        zIndex: theme => theme.zIndex.modal + GLOBAL_OVERLAY_ZINDEX_INCREASE,
      }}
    ></Backdrop>
  )
}
